import ApplicationRouter from '../ApplicationRouter';

function ApplicationContent() {
  return (
    <div
      id="mysw-content"
      className="mysw-content"
    >
      <ApplicationRouter />
    </div>
  );
}

export default ApplicationContent;
